import { Box, Flex } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from '../../common/components/TextBlock';
import { ROUTES } from '../../config';

export const Banner: React.FC = () => {
  return (
    <Box
      display={['grid', 'flex']}
      justifyContent={['initial', 'space-between', 'initial']}
      w={'100%'}
      maxW={'100%'}
      backgroundColor={'black'}
      overflow={'hidden'}
      borderRadius={'10px'}>
      <Box
        opacity={1}
        zIndex={3}
        h={'300px'}
        w={['100%', '50%']}
        minW={'50%'}
        px={'30px'}
        pt={['16px', '30px']}
        borderRadius={'10px'}>
        <Box
          p="2px"
          display="inline-block"
          background={'linear-gradient(to bottom, #63AAFF, #C7E0FF, #FFD698, #C4A8FF)'}
          borderRadius={'5px'}
          borderColor={'white'}
          margin={'0 0 8px 0'}>
          <Box bgColor={'black'} borderRadius="4px" px="8px">
            <TextBlock weight="bold" color={'white'} fontSize={'10px'} lineHeight="20px">
              Get Early Access!
            </TextBlock>
          </Box>
        </Box>
        <TextBlock weight="bold" color={'white'} fontSize={['30px', '30px', '30px', '48px']} lineHeight="1">
          Invest in rental homes.
        </TextBlock>
        <Flex flexWrap={'wrap'} paddingBottom={'24px'}>
          <TextBlock mr={'5px'} color={'gray.400'} fontSize={['16px', '16px', '20px']}>
            {'Institutional grade.'}
          </TextBlock>
          <TextBlock color={'gray.400'} fontSize={['16px', '16px', '20px']}>
            10-18% target returns.
          </TextBlock>
        </Flex>
        <Box
          as={Link}
          display={'inline-flex'}
          to={ROUTES.properties}
          backgroundColor={'white'}
          cursor={'pointer'}
          transition={'all 0.2s ease-in-out'}
          borderRadius={'10px'}
          padding="0 25px"
          _hover={{
            backgroundColor: 'blue.200',
          }}>
          <TextBlock color={'black'} fontSize="20px" weight="bold" lineHeight={'45px'}>
            Explore
          </TextBlock>
        </Box>
      </Box>
      <Box
        display={['grid', 'grid', 'flex']}
        width={['auto', '300px', '100%']}
        pr={['0px', '10px', '0px', '0px', '20px']}>
        <Image
          opacity={[0.4, 1]}
          zIndex={1}
          flex={[0, 1]}
          mt={['-175px', 0]}
          width={['100%', 'auto']}
          h={['175px', '300px']}
          image="dashboard-header"
          objectFit={'cover'}
          borderRightRadius={['0px', '10px']}
          borderBottomRadius={['10px', '0px']}
        />
      </Box>
    </Box>
  );
};
